import './teacher-drive-time-bubble.css'
import React from 'react'

import { HomeIcon, ChevronDownIcon, ChevronUpIcon, CalendarIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';
import { BsCalendar, BsCarFrontFill } from 'react-icons/bs';
import { ClockIcon } from '@heroicons/react/24/outline';
import { MdCalendarMonth, MdSchool } from 'react-icons/md';
import { createEllipses } from '../../../utilityFunctions';
import { MdMailOutline, MdCheck, MdClose, MdDoDisturb } from 'react-icons/md';


const calendarEventInfo = (suggestion) => (
        <div>
            <div className='temp-teacher-distance-info'>
                <div className='temp-teacher-distance-info__item temp-teacher-distance__teacher-name'>{createEllipses(suggestion.eventOrTeacherObject.name, 19)}</div>
            </div>
            {suggestion.distance === '1 ft' ? 
                    <div className='temp-teacher-distance-info'>
                        <MdSchool size={12} fill='#94A3B8' />
                        <div className='temp-teacher-distance-info__item temp-teacher-distance-info__distance-time'>at house {suggestion.eventOrTeacherObject.day} {suggestion.eventOrTeacherObject.time}</div>
                    </div>
                    :
                    <div className='temp-teacher-distance-info'>
                        <BsCarFrontFill size={12} fill='#94A3B8' />
                        <div className='temp-teacher-distance-info__item temp-teacher-distance-info__distance-time'>{suggestion.duration} | {suggestion.eventOrTeacherObject.day} {suggestion.eventOrTeacherObject.time}</div>
                    </div>
            }
        </div> 
)

const homeLocationInfo = (suggestion) => (
    <div>
        <div className='temp-teacher-distance-info'>
            <div className='temp-teacher-distance-info__item temp-teacher-distance__teacher-name'>{createEllipses(suggestion.eventOrTeacherObject.name, 19)}</div>
        </div>
        <div className='temp-teacher-distance-info'>
            <HomeIcon width={12} fill='#94A3B8' />
            <div className='temp-teacher-distance-info__item temp-teacher-distance-info__distance-time'>{suggestion.duration}</div>
        </div>
    </div>
)

const checkInvitationStatus = (invitations, suggestion) => {
    let styles = {
        color: '',
        icon: '',
        opacity: 0,
        iconType: ''
    }

    for(let i = 0; i < invitations.length; i++) {
            if(invitations[i].teacherName === suggestion.eventOrTeacherObject.name) {
                let invitation = invitations[i]
                    if(invitation.interested) {
                        styles.color = '#14B8A6'
                        styles.opacity = 1
                        styles.iconType = 'yes'
                    } else if (!invitation.interested && !invitation.dateResponded) {
                        styles.color = '#5cb0eb'
                        styles.opacity = 1
                        styles.iconType = 'mail'
                    } else if (!invitation.interested && invitation.dateResponded) {
                        styles.color = '#EF4444'
                        styles.opacity = 1
                        styles.iconType = 'no'
                    }
            } 
        }  
    return (
        <div style={{backgroundColor: styles.color, opacity: styles.opacity}} className='temp-teacher-distance-info__invitation-indicator'>
            {styles.iconType === 'mail' && <MdMailOutline color='#fff' />}
            {styles.iconType === 'yes' && <MdCheck color='#fff' />}
            {styles.iconType === 'no' && <MdClose color='#fff' />}
        </div>
    )
}

const TeacherDriveTimeBubble = ({suggestion, invitations, setSchedulingHelperTeacherId}) => {
    const [open, setOpen] = React.useState(false);
    const [iconSize, setIconSize] = React.useState(20);

    const dte = (suggestion) => {
        console.log(suggestion)
    }

    return (
        <div className="temp-teacher-distance-popup-item" style={suggestion.distance === '1 ft' ? {border: '2px solid rgb(13, 153, 255)'} : {border: '1px solid #E2E8F0'}}>
            <div className='temp-teacher-distance-info__wrapper'>
                {invitations && checkInvitationStatus(invitations, suggestion)}
                {!suggestion.eventOrTeacherObject.moreStudents && 
                    <div className='temp-teacher-distance-teacher-full'>
                        <MdDoDisturb opacity={0.8} size={50} color='#f8fafc' />
                    </div>
                }
                <img className='temp-teacher-distance-teacher-img' style={!suggestion.eventOrTeacherObject.moreStudents ? {opacity: 0.5} : {opacity: 1}} src={suggestion.eventOrTeacherObject.imageUrl[0] === 'h' ? suggestion.eventOrTeacherObject.imageUrl : `https://app.atharo.app/images/${suggestion.eventOrTeacherObject.imageUrl}`} alt="teacher" />
                {suggestion.eventOrTeacherObject.type === 'calendarEvent' ?
                    calendarEventInfo(suggestion)
                    :
                    homeLocationInfo(suggestion)
                }
                <div>
                    {/* {open ? <ChevronUpIcon cursor={'pointer'} width={20} fill='#94003B8' onClick={() => setOpen(false)} /> : <ChevronDownIcon width={20} cursor={'pointer'} fill='#94A3B8' onClick={() => setOpen(true)} />} */}
                        <MdCalendarMonth 
                            size={iconSize} 
                            color='gray' 
                            onMouseEnter={() => setIconSize(22)}
                            onMouseLeave={() => setIconSize(20)} 
                            cursor={'pointer'} 
                            onClick={() => setSchedulingHelperTeacherId(suggestion.eventOrTeacherObject.teacherId ? suggestion.eventOrTeacherObject.teacherId : suggestion.eventOrTeacherObject.id)}  
                        />
                </div>
            </div>
            {open && 
                <div className='temp-teacher-distance-info__bottom-drawer'>
                    <div className='temp-teacher-distance-info__calendar-event'>
                        <div className='temp-teacher-distance-info__calendar-event__name'>{suggestion.eventOrTeacherObject.familyName} Family</div>
                        <div className='temp-teacher-distance-info__calendar-event__time-wrapper'>
                            <ClockIcon color='#4BA2E3' width={9} />
                            <div className='temp-teacher-distance-info__calendar-event__time'>{suggestion.eventOrTeacherObject.time}</div>
                        </div>

                    </div>
                </div>
            }
        </div>
    )
}
export default TeacherDriveTimeBubble;